import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import Carousel from '../../../commonComponents/carousel/Carousel';
import ShopProductItem from './ShopProductItem';
import ProductProp from '../propTypes/productVariationsProp';
import ProductPlaceholder from './ShopProductPlaceholder';
import ServerSideCarousel from '../../../commonComponents/carousel/ServerSideCarousel';

const CAROUSEL_TYPE = {
  CATEGORY: 'category',
  PROMOTION: 'promotion',
  SIMILAR: 'similar',
  HIGHLIGHT: 'highlight',
};

function ShopPromoCarousel({
  title,
  carouselId,
  productList,
  type,
  productInfo,
  isLandingPagePromotion,
}) {
  let fetchUrl = '/shop/product/list';
  switch (type) {
    case CAROUSEL_TYPE.CATEGORY:
      fetchUrl = `/shop/product/category/${productInfo}`;
      break;
    case CAROUSEL_TYPE.HIGHLIGHT:
      fetchUrl = '/shop/product/highlights';
      break;
    case CAROUSEL_TYPE.PROMOTION:
      fetchUrl = '/shop/product/on-sale';
      break;
    case CAROUSEL_TYPE.SIMILAR:
      fetchUrl = `/shop/product/${productInfo}/related`;
      break;
    default:
      break;
  }

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m--margin-top-10 m--margin-bottom-10 shop-carousel-container">
      <div className="m-portlet__body carousel-container-title m--padding-bottom-10">
        <h3>{title}</h3>
      </div>
      <div className="m-portlet__body m--padding-top-5 m--padding-bottom-20 shop-carousel">
        <div className="row">
          <Carousel>
            <ServerSideCarousel
              id={carouselId}
              fetchUrl={fetchUrl}
              defaultFetchError="error_fetchCourses"
              placeholder={<ProductPlaceholder />}
              items={productList}
            >
              {items =>
                items.map(p => (
                  <ShopProductItem
                    compactDisplay
                    key={p._id}
                    product={p}
                    isLandingPagePromotion={isLandingPagePromotion}
                  />
                ))
              }
            </ServerSideCarousel>
          </Carousel>
        </div>
      </div>
    </div>
  );
}

ShopPromoCarousel.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  carouselId: PropTypes.string,
  productList: PropTypes.arrayOf(PropTypes.shape(ProductProp.propType)),
  type: PropTypes.oneOf(Object.values(CAROUSEL_TYPE)),
  productInfo: PropTypes.string,
  isLandingPagePromotion: PropTypes.bool,
};

ShopPromoCarousel.defaultProps = {
  type: '',
  carouselId: 'new-products-carousel',
  productList: [],
  productInfo: null,
  isLandingPagePromotion: false,
};

export default translate(ShopPromoCarousel);
